import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-100/95 backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <span className="text-2xl font-heading text-primary-500">
              牛牛影视
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 text-sm whitespace-nowrap rounded-lg transition-colors cursor-pointer ${
                  location.pathname.includes(`/category/${cat.slug}`)
                    ? 'bg-primary-500/20 text-primary-400'
                    : 'text-foreground-300 hover:text-foreground-100 hover:bg-background-200'
                }`}
              >
                <i className={`${cat.icon} mr-1.5`}></i>
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 text-sm whitespace-nowrap rounded-lg transition-colors cursor-pointer ${
                location.pathname === '/about'
                  ? 'bg-primary-500/20 text-primary-400'
                  : 'text-foreground-300 hover:text-foreground-100 hover:bg-background-200'
              }`}
            >
              <i className="ri-information-line mr-1.5"></i>
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-200 cursor-pointer"
            aria-label="菜单"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-100/95 backdrop-blur-md pb-4">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`flex items-center gap-3 px-4 py-3 text-sm cursor-pointer ${
                  location.pathname.includes(`/category/${cat.slug}`)
                    ? 'text-primary-400 bg-primary-500/10'
                    : 'text-foreground-300'
                }`}
              >
                <i className={`${cat.icon} text-base`}></i>
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`flex items-center gap-3 px-4 py-3 text-sm cursor-pointer ${
                location.pathname === '/about'
                  ? 'text-primary-400 bg-primary-500/10'
                  : 'text-foreground-300'
              }`}
            >
              <i className="ri-information-line text-base"></i>
              关于我们
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
}